/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../theme';

export const FilterSearchInputDropdownContainerStyled = styled.div`
    position: fixed;
    z-index: 10;
    max-width: 440px;
    max-height: 208px;
    min-width: fit-content;
    overflow: auto;
    box-sizing: border-box;
    padding: 8px 0;
    box-shadow: 0 2px 12px 0 rgba(51, 51, 51, 0.2);
    background: ${colors.tableFilterDropdownBg};

    &.no-items {
        display: none;
    }

    & .dropdown-item_highlight {
        background: transparent;
        ${fonts.textSmallBold};
        line-height: 1;
    }

    & .drop-down-filter__button-area {
        display: none;
    }
`;

export const FilterSearchInputDropdownItemTextStyled = styled.span.attrs({
    className: 'drop-down__item-text',
})`
    ${fonts.textSmall};
`;

export const FilterSearchInputDropdownItemStyled = styled.div.attrs({
    className: 'drop-down__item',
})`
    display: flex;
    align-items: center;
    max-width: 440px;
    height: 32px;
    padding: 0 32px 0 16px;
    box-sizing: border-box;
    cursor: pointer;
    line-height: 1;
    &:hover {
        background: ${colors.tableFilterItemColor};
    }
    & ${FilterSearchInputDropdownItemTextStyled} {
        line-height: 1;
    }
`;
